export enum BotPreset {
  AGGRESSIVE = 'AGGRESSIVE',
  MILD = 'MILD',
  CONSERVATIVE = 'CONSERVATIVE',
}
